// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_quill_dist_quill_js":"f19b7148c8c9da7b","src_app_gestion-plc_menu-plc_menu-plc_component_ts":"4df0c61e72fe38ff"}[chunkId] + ".js";
};